module.exports = (transactions, subtypes, store, mode) ->
  transactions = transactions.filter((tr) -> tr.subtype == 'i') if subtypes == 'incomes'
  transactions = transactions.filter((tr) -> tr.subtype == 'e') if subtypes == 'expenses'

  if mode == 'real'
    sumFn = store.getters.transactions_sum
    transactions = transactions.filter (tr) -> tr.real_amount && tr.real_amount != 0
  if mode == 'plan'
    sumFn = store.getters.transactions_plan_sum
    transactions = transactions.filter (tr) -> tr.type == 'planned'
  total = sumFn transactions

  reverse_mode = total > 0

  grouped = _.groupBy(transactions, 'category')

  only_one_category_present = Object.keys(grouped).length == 1

  grouped = _.map grouped, (trs, category) ->
    sum = sumFn(trs)
    {
      category: trs[0].category
      base_category: (if only_one_category_present then trs[0].category else trs[0].baseCategory())
      type: 'sub'
      sum: sum
      percentage: (_.round((sum / total) * 100) || 0)
      transaction_ids: _.map(trs, 'id')
    }
  grouped = _.groupBy grouped, 'base_category'
  grouped = Object.values(grouped).map (subcategories) ->
    subcategories = _.orderBy(subcategories, 'sum')
    subcategories = subcategories.reverse() if reverse_mode
    {
      category: subcategories[0].base_category
      subtype_and_name: "#{if reverse_mode then 'icomes' else 'expenses'}---#{subcategories[0].base_category}"
      sum: _.sumBy subcategories, 'sum'
      percentage: _.round(_.sumBy(subcategories, 'sum') / total * 100)
      type: 'parent'
      opened: false
      transaction_ids: _.flatten(_.map(subcategories, 'transaction_ids'))
      subcategories: (subcategories if subcategories.length > 1)
    }

  grouped = _.map grouped, (category_obj, base_category) -> category_obj
  categories = _.orderBy grouped, 'sum'
  categories = categories.reverse() if reverse_mode

  return {
    total: total
    categories: categories
  }
